import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  EVAvatar,
  EVBox,
  EVTypography,
  EVKeyboardArrowDown,
  EVBadge,
} from '@eagleview/ev-comp-library';
import useStyles from './UserProfileStyle';

/**
 * UserProfileErrorAvatar Component - renders a non-clickable avatar when there's a user profile error
 */
const UserProfileErrorAvatar = ({ monogramVariant }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <EVBox className={classes.box}>
        <EVBadge
          overlap="circular"
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          badgeContent={null} // No badge content in error state
        >
          <EVAvatar
            id="userAvatar"
            className={clsx({ [classes.avatarMicro]: monogramVariant === 'micro' },
              { [classes.avatarSmall]: monogramVariant === 'small' },
              { [classes.avatarMedium]: monogramVariant === 'medium' },
              { [classes.avatarLarge]: monogramVariant === 'large' })}
            style={{ cursor: 'default', opacity: 0.5 }}
          >
            --
          </EVAvatar>
        </EVBadge>
        { monogramVariant === 'medium' && (
          <EVKeyboardArrowDown
            id="keyboardArrowDown"
            className={classes.keyboardArrowDown}
            style={{ cursor: 'default', opacity: 0.5 }}
          />
        )}
      </EVBox>
      { monogramVariant === 'medium' && (
        <EVTypography id="fullName" className={classes.name} style={{ opacity: 0.5 }}>
          --
        </EVTypography>
      )}
    </div>
  );
};

UserProfileErrorAvatar.propTypes = {
  /**
   * Variant of monogram
   * @property {string} monogramVariant
   */
  monogramVariant: PropTypes.oneOf(['micro', 'small', 'medium', 'large']),
};

UserProfileErrorAvatar.defaultProps = {
  monogramVariant: 'small',
};

export default UserProfileErrorAvatar;
